<template>
    <div id="Rental_DashBoard">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template>
                <div class="page-name">
                    <span class="page-title" id="dashboard">Work Queue</span>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content dashboard-page">
                        <section class="internal-container border-top-table-fl">
                            <div class="form-row row-cols-md-4">
                                <div class="col form-group">
                                    <label class="control-label" for="state">Location:</label>
                                    <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" class='close-remove' :options="locationArr" @input="onLocationChange">
                                    </v-select>
                                </div>
                            </div>
                            <div class="reservation-dashboard-section" v-if="loadReservationList">
                                <asset-analytics id="asset-analytics" :fromModule="location_id" ref="loadassetanalytics"/>
                                <reservation-summary :reservationSummaryVal="potentialReservation" />
                                <reservation-summary :reservationSummaryVal="rentalReservation"/>
                            </div>
                            <template v-if="listPolicy">
                                <div class="reservation-dashboard-section">
                                    <hr class="light-hr" style="border-style:dashed;"/>
                                    <div class="dashboard-btm-section">
                                        <h5 class="color-darkblue font-semibold"> Insurance Policy </h5>
                                        <div class="dashboard-module-btm-section basic-form-container">
                                            <div class="table-responsive-sm">
                                                <table aria-describedby="table" id="contact_table" class="table table-sm font-1">
                                                    <thead>
                                                        <tr class="table-header">
                                                            <th>Policy Number</th>
                                                            <th>Policy Type</th>
                                                            <th>Self Insured For</th>
                                                            <th>Insurance Company</th>
                                                            <th>Customer Name</th>
                                                            <th>Status</th>
                                                            <th>Start Date</th>
                                                            <th>Expiry Date</th>
                                                            <th>Agent Name</th>
                                                            <th>Agent Phone</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="policyArr && policyArr.length > 0">
                                                            <tr v-for="(pol, polindex) in policyArr" v-bind:key="polindex">
                                                                <td>{{pol.policy_number}}</td>
                                                                <td>{{ pol.policy_type }}</td>
                                                                <td>{{ pol.self_insured_for }}</td>
                                                                <td>{{ pol.ins_company }}</td>
                                                                <td v-fp-html="pol.company"></td>
                                                                <td>{{ pol.status }}</td>
                                                                <td>{{ pol.start_date }}</td>
                                                                <td>{{ pol.expiry_date }}</td>
                                                                <td>{{ pol.agent_name }}</td>
                                                                <td>{{ pol.agent_phone }}</td>
                                                            </tr>
                                                        </template>
                                                        <template v-else>
                                                            <tr>
                                                                <td class="no-data-found" style="text-align:center" colspan="11">{{"No Data Found!"}}</td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="btn-groups text-right">
                                            <button type="submit" id="CreateCustomerBtn" class="btn btn-primary" v-on:click.prevent="viewAllPolicyDetail()" > <i class="fp-view"></i> View all
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </section>
                    </div>
                </div>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import ReservationSummary from "@/components/ReservationSummary.vue";
Vue.component("reservation-summary", ReservationSummary);
import AssetAnalytics from '@/components/dashboard/AssetAnalytics.vue';
Vue.component("asset-analytics", AssetAnalytics);

export default {
    name: "Rental-DashBoard",
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: true,
        loading:false,
        customer_id: "",
        customerArr: [],
        vehicle_id: "",
        vehicleArr: [],
        contract_id: "",
        contractArr: [],
        vendor_id: "",
        vendorArr: [],
        customer_error_msg: "",
        vehicle_error_msg: "",
        contract_error_msg: "",
        vendor_error_msg: "",
        potentialReservation: "potentialreservationlist",
        rentalReservation: "rentalreservationlist",
        listCrm:false,
        crmArr:[],
        serverParams: {
            columnFilters: {},
            sort: {
                field: "follow_up_date",
                type: "asc"
            },
            page: 1,
            perPage: 5
        },
        paymentArr:[],
        listPolicy:false,
        listCreditRequest:false,
        policyArr:[],
        loadReservationList:false,
        location_id: null,
        locationArr: [],
    }),
    watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        
                        if(permissions[i].name == 'list_insurance_policies') {
                            self.listPolicy = true;
                        }
                        
                    }
                }
            }
    },
    created: function() {

    },
    mounted: function() {
            var self = this;
            self.getPermissions();
            self.loadReservationList = true;
            self.listPolicyDetail();
            self.loadFieldData(['location']);
            var userObj = localStorage.getItem("user_obj");
            //if user logged in than remove login button and registration button
            if ( userObj != null ) {
                var userJson = JSON.parse(userObj);
                if(userJson && userJson.location_id != null && userJson.location_id  != ''){
                    self.location_id = {value: userJson.location_id, text: self.titleCase(userJson.locationName) };
                    console.log(self.location_id);
                }
            }
    },
    methods: {

        viewAllPolicyDetail() {
            var self = this;
            self.$router.push({ name: 'InsurancePolicyList', query: { from: "rental-dashboard" }});
        },
        
        listPolicyDetail() {
            var self = this;
            //call api only if user have permission to access the list
            if (self.listPolicy){
                self.loading = true;
                self.serverParams.columnFilters = '';

                var fields = {
                    page: self.serverParams.page,
                    perPage: 10,
                    filters: self.serverParams.columnFilters,
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    flag: "dashboard",
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/insurance/policy/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.policyArr = data.content.row;
                            // self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'bank-transferlist');
                    }
                });
            }
        },
        onLocationChange(evt){
            var self = this;
            self.location_id = {value: evt.value, text: self.titleCase(evt.text) };
            self.$refs.loadassetanalytics.location_id =self.location_id;
        },
    }
};
</script>




// WEBPACK FOOTER //
// src/components/RentalDashboard.vue